<template>
  <div class="widget-instructions-three">
    <p class="widget-instructions">
      {{ $t("widget_details.step_3") }}
    </p>
    <br />

    <div class="columns">
      <div class="column is-12">
        <div class="tile is-ancestor">
          <div class="tile is-parent">
            <div class="tile is-child box custom-tile code-demo">
              <div class="header">
                <ButtonCopy class="is-pulled-right is-small"></ButtonCopy>
              </div>
              <div class="instructions-box content">
                <p class="sample-code lorem-text">
                  &lt;p&gt;Lorem ipsum dolor sit amet, consectetur adipiscing
                  elit, sed do eiusmod tempor incididunt ut labore et dolore
                  magna aliqua.&lt;/p&gt;
                </p>
                <br />
                <div ref="text">
                  <p class="sample-code comment-code">
                    &lt;!--
                    {{ $t("widget_details.url_tag") }} --&gt;
                  </p>
                  <p
                    v-if="$i18n.locale == 'fr'"
                    class="sample-code script-text"
                  >
                    &lt;script<br />
                    &nbsp;&nbsp;type="text/javascript"<br />
                    &nbsp;&nbsp;src="{{ widget.widget_urlFr }}"&gt;<br />
                    &lt;/script&gt;
                  </p>
                  <p v-else class="sample-code script-text">
                    &lt;script<br />
                    &nbsp;&nbsp;type="text/javascript"<br />
                    &nbsp;&nbsp;src="{{ widget.widget_url }}"&gt;<br />
                    &lt;/script&gt;
                  </p>
                </div>
                <p class="sample-code lorem-code">
                  &nbsp;&lt;/body&gt; <br />
                  &lt;/html&gt;
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonCopy from "@/components/ButtonCopy.vue";
export default {
  name: "WidgetInstructionsThree",
  props: {
    widget: { type: Object, required: true }
  },
  data() {
    return {
      toggle: false,
      selectedData: [] // Must be an array reference
    };
  },
  components: {
    ButtonCopy
  }
};
</script>
<style lang="scss">
/* slide animation */
.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
p.click_title {
  margin-top: 12px;
  margin-bottom: 8px;
}
.instructions-box.content {
  padding: 10px;
}
@media screen and (max-width: 416px) {
  .is-pulled-right {
    font-size: 80%;
  }
  .code-demo {
    overflow-wrap: break-word;
  }
}
</style>
